/**
 * 获取代码（/setting/gencode/get）中所用到的
 * 变量配置
 */

const goods = [
  ['et', '30'],
  ['id', '商品id, 必填项'],
  ['vendorId', '供应商id'],
  ['name', '商品名称'],
  ['price', '商品现价'],
  ['url', '商品页面url'],
  ['id', '商品id'],
  ['img', '商品图片url'],
  ['thumb', '产品缩略图url'],
  ['brand', '品牌名'],
  ['brandID', '品牌id'],
  ['category', '分类信息共四级，1-name-id;2-name-id;3-name-id;4-name-id'],
  ['shelve', '商品上架时间'],
  ['unshelve', '商品下架时间'],
  ['originalPrice', '商品原·'],
  ['stock', '库存数量'],
  ['wishlist', '收藏人数'],
  ['merchant', '商家名称'],
  ['merchantId', '商家id'],
  ['site', '站点url'],
  ['logo', '商家Logo url'],
  ['des', '产品描述'],
  ['discount', '产品折扣'],
  ['isDiscount', '是否打折'],
  ['purchased', '已购买人数'],
  ['code', '货币代码'],
  ['region', '销售区域'],
  ['limitPrice', '限时价格'],
  ['limitStart', '限时开始时间'],
  ['limitEnd', '限时结束时间'],
  ['aDeep', '安卓 Deeplinkurl'],
  ['iDeep', 'IOS Deeplinkurl'],
  ['mobieUrl', '移动端落地页链接'],
];
const order = [
  ['et', '31'],
  ['id', '订单号,必填项'],
  ['itemId', '商品订单，商品ID为必填项'],
  ['vendorId', '供应商id'],
  ['orderType', '订单类型，0，此为常量请勿修改'],
  ['price', '订单总价']
];

const shoppingcart = [
  ['et', '32'],
  ['id', '商品ID, 必填项'],
  ['vendorId', '供应商id'],
  ['name', '商品名称'],
  ['price', '商品价格'],
  ['quantity', '商品数量']
];

export default {
  goods,
  order,
  shoppingcart
};




// WEBPACK FOOTER //
// ./src/pageview/setting/CODE_VAR_CONFIG.js